import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadTradePlatform = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.75 18H18.25M10 15V1.75M6 11L10 15L14 11",
		stroke: "",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgDownloadTradePlatform;
